export const CONNEXION_EN_TANT_QUE_COOKIE_NAME = 'M_FRONT_CONNECT_AS';
